var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-sm-5"},[_c(_vm.currentComponent,_vm._b({tag:"component",on:{"activeEditMode":_vm.editMode,"activeViewMode":_vm.enableViewMode,"goToCheckList":_vm.goToCheckList}},'component',_vm.props,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }